import React from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { Icon } from "rhombus-react";
import { EmptyDash } from "./EmptyDash";
import { DECISIONING_ICON_MAP, DECISIONING_TYPES, VERSION_STATUS } from "utils/constants";
import { tellSentry } from "utils/Rave";
import { isSocialCreative } from "utils/common";

import "./VersionStatusColumn.css";

export default function VersionStatusColumn(props) {
	let { value, dependentValues } = props
		, { decisioningTypeSelector, adType } = dependentValues
		, decisioningType = useSelector(decisioningTypeSelector)
		, versionStatus = DECISIONING_ICON_MAP[decisioningType] ?? DECISIONING_ICON_MAP.unknown
		, $icon = null
		, cellClass = "version-status-cell"
		;

	// Need to assign social creative approved icon manually since decisionType is always passed as 'No Decisioning'
	if (isSocialCreative({ adType }) && value === VERSION_STATUS.LIVE) {
		versionStatus = DECISIONING_ICON_MAP[DECISIONING_TYPES.PUBLISHED_VERSION];
	}

	const { iconName, iconClass, iconStyle, label=null } = versionStatus;

	if(decisioningType && (label === DECISIONING_ICON_MAP.unknown.label)){
		tellSentry(`Unknown Creative decisioningType: ${decisioningType}`);
	}

	if(value===VERSION_STATUS.LIVE){
		$icon = <Icon name={iconName} className={iconClass} iconStyle={iconStyle} />;
	} else if(value===VERSION_STATUS.UNPUBLISHED){
		return(
			<div>
				 <EmptyDash />
			</div>
		);
	} else {
		tellSentry(`Unknown Version status: ${value}`);
	}

	return (
		<div className={classNames(cellClass, { "status-label": label })}>
			{$icon}
			{label}
		</div>
	);
}


VersionStatusColumn.defaultProps={
	value: "",
	dependentValues:{},
};
